import { FetchRareSkillsParams } from "PFCore/services/skills/fetch_rare_skills";
import { Id, QueryParams } from "PFTypes";

export const skillsKeys = {
  all: () => ["skills"],
  single: (id: Id) => [...skillsKeys.all(), id.toString()],
  discovered: () => [...skillsKeys.all(), "discovered"],
  rare: (params: FetchRareSkillsParams) => [...skillsKeys.all(), "rare", params],
  framework: (params: QueryParams = {}) => [...skillsKeys.all(), "framework", params]
};
